module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/sections--vision-values.474e6ef.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/sections--vision-values.pdf
// module id = 7AqK
// module chunks = 10